import { render, staticRenderFns } from "./index.vue?vue&type=template&id=053973ce&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=053973ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053973ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053973ce')) {
      api.createRecord('053973ce', component.options)
    } else {
      api.reload('053973ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=053973ce&scoped=true&", function () {
      api.rerender('053973ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TipMsg/index.vue"
export default component.exports